export const theme = 
{ 
    colors: 
    { 
        primary: '#0f172a',
        primaryLight: '#131c31',
        secondary: '#7eadfc',
        white: '#fff',
        black: '#000',
        paraTextColor: '#dcdcdc',
        gray: '#353b48',
        shadow: "#636e72",
    },
    fonts:
    {
        family: 'Inconsolata',
        weight: { regular : 400, medium: 500, bold: 700, }
    },

    breakpoints:
    {
        mobile: '720px',
    }, 

    boxShadow: { hOffset: 0, vOffset: 0, blur: '6px', spread : '4px' }


}